class NoteStore {
  baseKey = '';
  lastId = -1;

  constructor(localStorageKey) {
    if (localStorageKey) {
      this.baseKey = localStorageKey;
    }
  }

  // *** public methods ***

  addNote(notes, newNote) {
    this.lastId = this.lastId + 1;
    const newNotes = { ...notes, [this.lastId]: newNote }
    this.storeIds(newNotes);
    this.storeLastId();
    this.storeNote(newNotes, this.lastId);
    return [newNotes, this.lastId];
  }

  deleteNote(notes, id) {
    let newNotes = { ...notes }
    delete newNotes[id];
    this.removeNote(id);
    this.storeIds(newNotes);
    return newNotes;
  }

  retrieveAllNotes() {
    // TODO: what if retrieval problem?
    const ids = this.retrieveIds();
    if (ids) {
      // get lastId
      this.lastId = this.retrieveLastId();
      // get notes
      let notes = {};
      ids.forEach((id, i) => {
        notes[id] = this.retrieveNote(id);
      });
      return notes;
    }
    // No notes
    return null;
  }

  updateNote(notes, id, updatedNote) {
    const newNotes = {
      ...notes,
      [id]: updatedNote,
    }
    this.storeNote(newNotes, id);
    return newNotes;
  }

  // *** private methods ***

  remove(key) {
    const storage = window.localStorage;
    storage.removeItem(key);
  }

  retrieve(key) {
    const storage = window.localStorage;
    const item = storage.getItem(key);
    return item;
  }

  store(key, value) {
    const storage = window.localStorage;
    try {
      storage.setItem(key, value);
      return null;
    } catch (e) {
      // TODO: handle exceptions
      //console.error(e.name + ': ' + e.message);
      return e;
    }
  }

  removeNote(id) {
    const key = this.baseKey + '-note-' + id;
    this.remove(key)
  }

  retrieveIds() {
    const key = this.baseKey + '-ids';
    const text = this.retrieve(key);
    return JSON.parse(text);
  }

  retrieveLastId() {
    const key = this.baseKey + '-lastId';
    return parseInt(this.retrieve(key));
  }

  retrieveNote(id) {
    const key = this.baseKey + '-note-' + id;
    const text = this.retrieve(key);
    return JSON.parse(text);
  }

  storeIds(notes) {
    const key = this.baseKey + '-ids';
    const ids = Object.keys(notes);
    this.store(key, JSON.stringify(ids));
  }

  storeLastId() {
    const key = this.baseKey + '-lastId';
    this.store(key, this.lastId);
  }

  storeNote(notes, id) {
    const key = this.baseKey + '-note-' + id;
    this.store(key, JSON.stringify(notes[id]));
  }
}

export default NoteStore;
